import { SystemStyleObject } from '@chakra-ui/react';
import { ColorMode } from '@allergan-data-labs/alle-elements-core';
import { getActionListItemStyles } from '@allergan-data-labs/alle-elements-action-menu';
import { InputSelectVariant } from './input-select';

type Size = 'sm' | 'md';
const heights = {
  sm: '48px',
  md: '56px',
};

const paddingY = {
  sm: 12,
  md: 16,
};
export const getListContainerStyles = (isOpen: boolean): SystemStyleObject => ({
  position: 'relative',
  marginTop: '1',
  '> div': {
    width: '100%',
  },
  '.chakra-menu__menu-list': {
    display: isOpen ? 'block' : 'none',
  },
});

export const getAdditionalTextFieldStyles = (
  colorMode: ColorMode,
  size: Size,
  removeFocusBorder: boolean,
  selected: string[],
  isFiltereed: boolean,
  variant: InputSelectVariant
): SystemStyleObject => ({
  minHeight: heights[size],
  h: heights[size],
  textOverflow: 'ellipsis',
  backgroundColor: `${colorMode}.Container/Neutral/Base`,
  caretColor:
    variant === 'list' ? 'transparent' : `${colorMode}.Text/Neutral/Default`,
  color: `${colorMode}.Text/Neutral/Default`,
  paddingLeft: `${
    12 +
    (variant === 'multiselect' && selected.length > 0
      ? 32 + 8 + 8 * (Math.log10(selected.length) + 1)
      : 0)
  }px`,
  // For a chip with N number of selected items (chip is visible)
  // 12 pixels left padding +
  // 32 pixels for the width of a chip with a single digit +
  // 8 pixel gap
  // 6 pixels for every extra digit
  paddingRight: isFiltereed ? '72px' : '42px',
  py: paddingY[size],
  borderColor: `${colorMode}.Border/Neutral/Text field/Enable`,
  borderRadius: 'Small',
  _hover: {
    borderColor: `${colorMode}.Border/Neutral/Text field/Hover`,
    outlineColor: 'transparent',
  },
  _focus: {
    borderColor: `${colorMode}.Border/Neutral/Text field/Hover`,
    outlineColor: removeFocusBorder
      ? 'transparent'
      : `${colorMode}.Border/Brand/Focus ring/Default`,
  },
  _active: {
    outlineColor: 'transparent',
  },
});

export const getFocusedActionListItemStyles = (
  colorMode: ColorMode
): SystemStyleObject | undefined => {
  const styles = getActionListItemStyles(colorMode) as Partial<{
    _focusVisible: SystemStyleObject;
  }>;

  return styles._focusVisible;
};

export const getOptionsListStyles = (
  colorMode: ColorMode
): SystemStyleObject => ({
  ...getActionListItemStyles(colorMode),
  color: `${colorMode}.Text/Neutral/Default`,
  position: 'relative',
});

export const getElementStyles = (
  side: 'left' | 'right'
): SystemStyleObject => ({
  height: '100%',
  [`${side === 'left' ? 'marginLeft' : 'marginRight'}`]: '12',
  justifyContent: side === 'left' ? 'start' : 'end',
});

export const getRightElementContentStyles = (): SystemStyleObject => ({
  display: 'flex',
  flexDirection: 'row',
});

export const getCloseIconStyles = (
  colorMode: ColorMode
): SystemStyleObject => ({
  color: `${colorMode}.Icon/Neutral/Default`,
  borderRadius: 'Circle',
});

export const getClearIconStyles = (
  colorMode: ColorMode
): SystemStyleObject => ({
  borderRadius: 'Circle',
  height: '24px',
  width: '24px',
  minWidth: '24px',
  minHeight: '24px',
  lineHeight: '1',
  _focusVisible: {
    outlineColor: `${colorMode}.Border/Brand/Focus ring/Default`,
    outlineStyle: 'solid',
    outlineWidth: '4px',
    outlineOffset: '-4px',
  },
});
